export default __webpack_public_path__ + "static/media/SndLowerBDiveDown.484303e0.mp3";